import { ReactNode } from 'react';
import styled from 'styled-components';
import { useTheme } from '@mui/material';
import { ReactComponent as BarGraphIcon } from '../../assets/24x24/bar-graph.svg';
import { ReactComponent as ArchiveIcon } from '../../assets/archive.svg';
import { componentToken } from '../../style/utils';

const DataIcon = styled(BarGraphIcon)`
  color: ${componentToken('emptyState.icon')};
`;

const ListIcon = styled(ArchiveIcon)`
  color: ${componentToken('emptyState.icon')};
`;

type Props = {
  fallback: ReactNode;
  // Data views show a chart icon; lists show the archive.
  kind?: 'list' | 'data';
};

// Looks with an empty-state icon color draw an icon in place of the
// illustration.
const EmptyStateGraphic = ({ fallback, kind = 'list' }: Props) => {
  const { icon } = useTheme().tokens.components.emptyState;

  if (!icon) return <>{fallback}</>;

  return kind === 'data' ? <DataIcon /> : <ListIcon />;
};

export default EmptyStateGraphic;
